<template>
  <div class="col-xs-12 area_padding">
    <div class="row">
      <div class="col-xs-12 text-center mt60">
        <button id="btnReset"
                class="btn btn_set"
                type="button" @click="functionRestoreDefault()">{{ $t('setting.button.reset') }}</button>
        <button id="btnRestore"
                class="btn btn_set"
                type="button" @click="funcResetSetting()"
                :disabled="restoreBtnDisable">{{ $t('setting.button.restoreDefaults') }}</button>
        <button id="btnApply"
                class="btn btn_set"
                type="button" @click="funcSaveSetting()"
                :disabled="maintenanceError.status">{{ $t('setting.button.apply') }}</button>
      </div>
      <div class="col-xs-12 mb40">
        <h3 class="title_underLine">{{ $t('setting.overallPerformance.overallPerformanceText') }}</h3>
        <ul class="mode_setting list-unstyled">
          <li class="pic-box">
            <div id="btnPerformanceClimbing"
                 class="hoverimg pic_43"
                 :class="{ 'active': driverPowerInfo.PerfMode === 'MTB' }"
                 @click="funcChangePerformanceMode('CLIMBING')">
              <a href="javascript:;"
                 class="overlay">
                <span class="overlay_content">{{ $t('setting.overallPerformance.climbing') }}</span>
              </a>
            </div>
          </li>
          <li class="pic-box">
            <div id="btnPerformanceTrekking"
                 class="hoverimg pic_43"
                 :class="{ 'active': driverPowerInfo.PerfMode === 'Trekking',
                           'box_disabledStyle': boolLockFeatures }"
                 @click="funcChangePerformanceMode('TREKKING')">
              <a href="javascript:;"
                 class="overlay">
                <span class="overlay_content">{{ $t('setting.overallPerformance.trekking') }}</span>
              </a>
            </div>
          </li>
          <li class="pic-box">
            <div id="btnPerformanceCity"
                 class="hoverimg pic_43"
                 :class="{ 'active': driverPowerInfo.PerfMode === 'City',
                           'box_disabledStyle': boolLockFeatures }"
                 @click="funcChangePerformanceMode('CITY')">
              <a href="javascript:;"
                 class="overlay">
                <span class="overlay_content">{{ $t('setting.overallPerformance.city') }}</span>
              </a>
            </div>
          </li>
        </ul>
        <div class="system_sleep mt50">
          <p>{{ $t('setting.overallPerformance.systemAutoSleep') }} ({{ $t('setting.overallPerformance.minute') }})</p>
          <div class="rangeBar">
            <span>{{ $t('setting.overallPerformance.min') }}</span>
            <InputRange :min="1" :max="60" :step="1" :value="inputRangeVal.autoSleep" v-model="inputRangeVal.autoSleep" />
            <span>{{ $t('setting.overallPerformance.max') }}</span>
          </div>
          <p>{{inputRangeVal.autoSleep}} {{ $t('setting.overallPerformance.minute') }}</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <h3 class="title_underLine">{{ $t('setting.userInterface.userInterfaceText') }}</h3>
        <ul class="list_settingList list-unstyled">
          <li :class="settingParameter.UserInterfacePresent.IsShow? '':'disable_list'">
            <h5>{{ $t('setting.userInterface.userInterfacePresent') }}：</h5>
            <div class="btn-group btn-group-justified"
                 role="group"
                 aria-label="...">
              <div class="btn-group"
                   role="group">
                <a href="#" class="btn btn_setting" role="button"
                   :class="{ 'disabled': !settingParameter.UserInterfacePresent.SupportWrite,
                             'active':userInterfacePresent === 0 }"
                  >
                  <img src="@/assets/images/setting/setting_04.png"
                       alt="">
                </a>
              </div>
              <div class="btn-group"
                   role="group">
                <a href="#" class="btn btn_setting" role="button"
                   :class="{ 'disabled': !settingParameter.UserInterfacePresent.SupportWrite,
                             'active':userInterfacePresent === 1 }">
                  <img src="@/assets/images/setting/setting_05.png"
                       alt="">
                </a>
              </div>
            </div>
          </li>
          <li :class="settingParameter.EnergyIndicator.IsShow? '':'disable_list'">
            <h5>{{ $t('setting.userInterface.energyIndicatorBarInLCD') }}：</h5>
            <div class="btn-group btn-group-justified" data-toggle="buttons">
              <label id="btnEnergyIndicatorON"
                     class="btn btn_setting"
                     :class="{ 'disabled': !settingParameter.EnergyIndicator.IsShow,
                               'active': energyIndicatorBar === 1 }"
                     @click="energyIndicatorBar=1">
                <input type="radio" name="options" id="lcd1" value="1" v-model="energyIndicatorBar"> ON
              </label>
              <label id="btnEnergyIndicatorOFF"
                     class="btn btn_setting"
                     :class="{ 'disabled': !settingParameter.EnergyIndicator.IsShow,
                               'active':energyIndicatorBar === 0 }"
                     @click="energyIndicatorBar=0">
                <input type="radio" name="options" id="lcd2" value="0" v-model="energyIndicatorBar"> OFF
              </label>
            </div>
          </li>
          <li>
            <h5>{{ $t('setting.userInterface.lightOnAtStartUp') }}：</h5>
            <div class="btn-group btn-group-justified" data-toggle="buttons">
              <label id="btnLightStartYES" class="btn btn_setting" :class="lightOnStart === 1?'active':''"  @click="lightOnStart=1">
                <input type="radio" name="options" id="light1" value = "1" v-model="lightOnStart"> YES
              </label>
              <label id="btnLightStartNO" class="btn btn_setting" :class="lightOnStart === 0?'active':''" @click="lightOnStart=0">
                <input type="radio" name="options" id="light2" value = "0" v-model="lightOnStart"> NO
              </label>
            </div>
          </li>
          <li :class="settingParameter.SpeedUnits.IsShow? '':'disable_list'">
            <h5>{{ $t('setting.userInterface.displayUnits') }}：</h5>
            <div class="btn-group btn-group-justified" data-toggle="buttons">
              <label id="btnSpeedUnitsKM"
                     class="btn btn_setting"
                     :class="{ 'disabled': !settingParameter.SpeedUnits.IsShow,
                               'active': speedUnits === 0 }"
                     @click="speedUnits=0">
                <input type="radio" name="options" id="displayUnit1" value="0" v-model="speedUnits"> KM/H
              </label>
              <label id="btnSpeedUnitsMPH"
                     class="btn btn_setting"
                     :class="{ 'disabled': !settingParameter.SpeedUnits.IsShow,
                               'active': speedUnits === 1}"
                     @click="speedUnits=1">
                <input type="radio" name="options" id="displayUnit2" value="1" v-model="speedUnits"> MPH
              </label>
            </div>
          </li>
          <li>
            <h5>{{ $t('setting.userInterface.powerlevelAtStartUp') }}：</h5>
            <div class="btn-group btn-group-justified" data-toggle="buttons">
              <label id="btnPowerLevelStartLast" class="btn btn_setting" :class="powerLevelStart > 9 ?'active':''" @click="powerLevelStart=10">
                <input type="radio" name="options" id="PowerLevel1" value="10" v-model="powerLevelStart"> {{ $t('setting.userInterface.lastUsed') }}
              </label>
              <label id="btnPowerLevelStartLvl1" class="btn btn_setting" :class="powerLevelStart === 1?'active':''" @click="powerLevelStart=1">
                <input type="radio" name="options" id="PowerLevel2" value="1" v-model="powerLevelStart"> {{ $t('setting.userInterface.level1') }}
              </label>
            </div>
          </li>
          <!-- <li :class="settingParameter.WriteWheelSize.IsShow? '':'disable_list'">
            <h5>{{ $t('setting.userInterface.wheelSize') }}：</h5>
            <div class="rangeBar wheel">
              <InputRange id="wheelSize" :tag="wheelSize" :min="950" :max="2450" :step="1" :value="inputRangeVal.wheelSize" v-model="inputRangeVal.wheelSize" />
              <span>{{inputRangeVal.wheelSize}} mm</span>
            </div>
          </li> -->
        </ul>
      </div>
      <div class="col-sm-12 col-md-4">
        <h3 class="title_underLine">{{ $t('setting.driveBehaviour.driveBehaviourText') }}</h3>
        <ul class="list_settingList list-unstyled">
          <li :class="settingParameter.TorqueResponse.IsShow? '':'disable_list'">
            <h5>{{ $t('setting.driveBehaviour.torqueSensorResponse') }}：</h5>
            <div class="btn-group btn-group-justified" data-toggle="buttons">
              <label id="btnTorqueResponseHigh"
                     class="btn btn_setting"
                     :class ="{ 'active': torqueResponse === 100,
                                'disabled': !settingParameter.TorqueResponse.IsShow }"
                     @click="torqueResponse=100">
                <input type="radio" name="options" id="TorqueResponse1" value="100" v-model="torqueResponse"> {{ $t('setting.driveBehaviour.high') }}
              </label>
              <label id="btnTorqueResponseNormal"
                     class="btn btn_setting"
                     :class ="{ 'active': torqueResponse === 50,
                                'disabled': !settingParameter.TorqueResponse.IsShow }"
                     @click="torqueResponse=50">
                <input type="radio" name="options" id="TorqueResponse2" value="50"  v-model="torqueResponse"> {{ $t('setting.driveBehaviour.normal') }}
              </label>
              <label id="btnTorqueResponseOFF"
                     class="btn btn_setting"
                     :class ="{ 'active':torqueResponse===0,
                                'disabled': !settingParameter.TorqueResponse.IsShow }"
                     @click="torqueResponse=0">
                <input type="radio" name="options" id="TorqueResponse3" value="0"  v-model="torqueResponse"> {{ $t('setting.driveBehaviour.off') }}
              </label>
            </div>
          </li>
          <li>
            <h5>{{ $t('setting.driveBehaviour.powerlevels') }}：</h5>
            <div class="btn-group btn-group-justified" data-toggle="buttons">
              <label class="label_levelBox">
              {{driverPowerInfo.Levels}}
              </label>
            </div>
          </li>
          <li :class="settingParameter.PowerlevelsAdjustment.IsShow ? '' : 'disable_list'">
            <h5 class="mt30">{{ $t('setting.driveBehaviour.powerlevelsAdjustment') }}：</h5>
            <ul class="list_sortStyle list-unstyled">
              <!-- <li v-for="(level,index) in inputRangeVal.powerlevelAdjust" :key="index">
                <div class="inp_powerLevel">
                  <span>{{level/10}}%</span> // start
                  <div class="rangeBar">
                    <span>1000</span> // 調的值
                    <InputRange :tag="'powerlevelAdjust' + index" :min="0" :max="1000" :step="10" :value="inputRangeVal.powerlevelAdjust[index]" v-model="inputRangeVal.powerlevelAdjust[index]" />
                  </div>
                  <span>{{level/10}}%</span> // end
                </div>
              </li> -->
              <li v-for="(level,index) in this.funcDriverPowerLv(driverPowerInfo.PerfMode,driverPowerInfo.Levels)" :key="index">
                <b>L{{ index+1 }}</b>
                <div class="inp_powerLevel">
                  <span>{{inputRangeVal.powerlevelAdjust[level-1]/10}}%</span>
                  <div class="rangeBar">
                    <span>{{inputRangeVal.powerlevelAdjust[level]/10}}%</span>
                    <InputRange :disabled="!settingParameter.PowerlevelsAdjustment.IsShow"
                                :tag="'powerlevelAdjust' + index"
                                :min= parseInt(inputRangeVal.powerlevelAdjust[level-1])
                                :max= parseInt(inputRangeVal.powerlevelAdjust[level+1])
                                v-model="inputRangeVal.powerlevelAdjust[level]" />
                  </div>
                  <span>{{inputRangeVal.powerlevelAdjust[level+1]/10}}%</span>
                </div>
              </li>
            </ul>
          </li>
          <!-- 輪徑 最大值 2450 最小值 950
          <li :class="settingParameter.WriteWheelSize.IsShow? '':'disable_list'">
            <h5>{{ $t('setting.userInterface.wheelSize') }}：</h5>
            <div class="rangeBar wheel">
              <InputRange id="wheelSize" :tag="wheelSize" :min="950" :max="2450" :step="1" :value="inputRangeVal.wheelSize" v-model="inputRangeVal.wheelSize" />
              <span>{{inputRangeVal.wheelSize}} mm</span>
            </div>
          </li> -->
        </ul>
      </div>
      <div class="col-sm-12 col-md-4">
        <h3 class="title_underLine">{{ $t('setting.maintenance.maintenanceText') }}</h3>
        <ul class="list_settingList list-unstyled">
          <li>
            <h5>{{ $t('setting.maintenance.maintenanceWarnings') }}：</h5>
            <div class="btn-group btn-group-justified" data-toggle="buttons">
              <label id="btnMaintainWarningON" class="btn btn_setting" :class="maintenanceWarnings === 1?'active':''" @click="maintenanceWarnings=1">
                <input type="radio" name="options" id="MaintenanceWarning1" value="1" v-model ="maintenanceWarnings"> ON
              </label>
              <label id="btnMaintainWarningOFF" class="btn btn_setting" :class="maintenanceWarnings === 0?'active':''" @click="maintenanceWarnings=0">
                <input type="radio" name="options" id="MaintenanceWarning2" value="0" v-model ="maintenanceWarnings"> OFF
              </label>
            </div>
          </li>
          <li>
            <h5>{{ $t('setting.maintenance.nextMaintenanceWarning') }}：</h5>
            <ul class="table_price list_titleStyle list-unstyled">
              <li :data-tit="$t('setting.maintenance.currentOdo')">
                <div data-cur="Km">{{bikeODO}}</div>
              </li>
              <li :data-tit="$t('setting.maintenance.nextMaintenanceOdo')">
                <div data-cur="Km"
                     class="form-inline">
                  <p class="form-group">
                    <label for="conf_priceDiscount"
                           class="sr-only">confirm discount</label>
                    <input id="conf_priceDiscount"
                           type="number"
                           placeholder="0"
                           v-model="maintenanceODO"
                           class="form-control">
                  </p>
                </div>
              </li>
              <div v-if = "maintenanceError.status" :class="{'error-red':maintenanceError.status}">{{maintenanceError.text}}</div>
            </ul>
          </li>
          <li :class="settingParameter.TirePressurePresent.IsShow? '':'disable_list'">
            <h5>{{ $t('setting.maintenance.tirePressureSensorPresent') }}：</h5>
            <div class="btn-group btn-group-justified" data-toggle="buttons">
              <label class="btn btn_setting"
                     :class="{ 'disabled': !settingParameter.TirePressurePresent.SupportWrite,
                               'active': tirepressurePresent === 1 }">
                <input type="radio" name="options" id="TirePressure1" value="1" v-model="tirepressurePresent"> YES
              </label>
              <label class="btn btn_setting"
                     :class="{'disabled': !settingParameter.TirePressurePresent.SupportWrite,
                              'active':tirepressurePresent === 0 }">
                <input type="radio" name="options" id="TirePressure2" value="0" v-model="tirepressurePresent"> NO
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-xs-12 mb30" :class="{ 'no_Support': !settingParameter.ConnectModulePresent.IsShow }">
        <h3 class="title_underLine">{{ $t('setting.userInterface.partsSupportText') }}</h3>
        <ul class="list_settingInline list-unstyled">
          <li :class="settingParameter.ConnectModulePresent.IsShow? '':'state_show'">
            <h5 :class ="{ 'active': connectModulePresent.Battery === 1 }">{{ $t('setting.userInterface.connectedBatteryPresent') }}：</h5>
          </li>
          <li :class="settingParameter.ConnectModulePresent.IsShow? '':'state_show'">
            <h5 :class ="{ 'active': connectModulePresent.Driver === 1 }">{{ $t('setting.userInterface.connectedDriverPresent') }}：</h5>
          </li>
          <li :class="settingParameter.ConnectModulePresent.IsShow? '':'state_show'">
            <h5 :class ="{ 'active': connectModulePresent.Display === 1 }">{{ $t('setting.userInterface.connectedDisplayPresent') }}：</h5>
          </li>
          <li :class="settingParameter.ConnectModulePresent.IsShow? '':'state_show'">
            <h5 :class ="{ 'active': connectModulePresent.Console === 1 }">{{ $t('setting.userInterface.connectedConsolePresent') }}：</h5>
          </li>
          <li :class="settingParameter.ConnectModulePresent.IsShow? '':'state_show'">
            <h5 :class ="{ 'active': connectModulePresent.IotModule === 1 }">{{ $t('setting.userInterface.connectedIotModulePresent') }}：</h5>
          </li>
          <li :class="settingParameter.ConnectModulePresent.IsShow? '':'state_show'" >
            <h5 :class ="{ 'active': connectModulePresent.SmartLock === 1 }">{{ $t('setting.userInterface.connectedSmartLockPresent') }}：</h5>
          </li>
        </ul>
      </div>
    </div>
    <uiv-modal v-model="modalOpen" class="v-modal-style" :backdrop="!boolDisconnect">
      <h4 slot="header" class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button
          type="button"
          id="btnOK"
          class="btn btn-default"
          @click="modal.btnAction.ok">{{ modal.btn.ok }}</button>
        <button
          v-show="!isHideBtn"
          type="button"
          id="btnCancel"
          class="btn btn-default"
          @click="modal.btnAction.cancel">{{ modal.btn.cancel }}</button>
      </template>
    </uiv-modal>
    <uiv-modal v-model="modalOpenDisconnect" class="v-modal-style" :backdrop="false">
      <h4 slot="header" class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button
          id="btnOK"
          type="button"
          class="btn btn-default mb20"
          @click="funcOkBtnDialog">{{ modal.btn.ok }}</button>
      </template>
    </uiv-modal>
    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { websocketAPI, settingAPI } from '@/mixins/websocket-api';
import InputRange from '@/components/Input-range';
import Loading from '@/components/Loading';
import { funcOriginalPartNo } from '@/utils/allowPartNo';

export default {
  name: 'Setting',
  mixins: [websocketAPI, settingAPI],
  data () {
    return {
      isLoading: true,
      restoreFlag: false,
      settingStepCount: 0,
      boolDisconnect: false,
      modalOpen: false,
      modalOpenDisconnect: false,
      modal: {
        data: {
          title: this.$t('bikeOverview.modalTitle'),
          content: this.$t('bikeOverview.modalContent')
        },
        btnAction: {
          ok: this.funcCloseDialog,
          cancel: this.funcCloseDialog
        },
        btn: {
          ok: this.$t('bikeOverview.modalBtnOk'),
          cancel: this.$t('bikeOverview.modalBtnCancel')
        }
      },
      paraVer: '',
      // for setting write & read
      inputRangeVal: {
        autoSleep: 6,
        wheelSize: 0,
        powerlevelAdjust: [],
        powerlevelAdjustCache: []
      },
      energyIndicatorBar: 8,
      lightOnStart: 8,
      speedUnits: 8,
      speedLimit: 25,
      powerLevelStart: 8,
      wheelSize: 1000,
      torqueResponse: 8,
      maintenanceWarnings: 8,
      autoSleep: 8,
      maintenanceODO: 8,
      // powerlevelAdjust: [],
      driverPowerInfo: {
        Levels: 8,
        PerfMode: 'City'
      },
      regenerativeBreaking: 8,
      // for setting read
      bikeODO: 0,
      userInterfacePresent: 8,
      connectModulePresent: {
        IotModule: 8,
        SmartLock: 8,
        Battery: 8,
        Driver: 8,
        Display: 8,
        Console: 8,
        FrontTpms: 8,
        RearTpms: 8
      },
      tirepressurePresent: 8,
      // read setting data form MG
      readSettingData: {
        userInterfacePresent: 8,
        energyIndicatorBar: 8,
        lightOnStart: 8,
        speedUnits: 8,
        powerLevelStart: 8,
        wheelSize: 8,
        autoSleep: 8,
        connectModulePresent: {
          IotModule: 8,
          SmartLock: 8,
          Battery: 8,
          Driver: 8,
          Display: 8,
          Console: 8
        },
        powerlevelAdjust: [],
        torqueResponse: 8,
        DriverPowerInfo: {
          Levels: 8,
          PerfMode: '00'
        },
        maintenanceODO: 8,
        regenerativeBreaking: 8,
        maintenanceWarnings: 8,
        tirepressurePresent: 8
      },
      settingParameter: {
        'UserInterfacePresent': {
          'IsShow': false,
          'SupportWrite': false,
          'Function': ''
        },
        'EnergyIndicator': {
          'IsShow': false,
          'SupportWrite': true,
          'Function': this.funcWriteEnergyBar
        },
        'ConnectModulePresent': {
          'IsShow': false,
          'SupportWrite': false,
          'Function': ''
        },
        'TirePressurePresent': {
          'IsShow': false,
          'SupportWrite': false,
          'Function': ''
        },
        'TorqueResponse': {
          'IsShow': true,
          'SupportWrite': true,
          'Function': this.fucnWriteTorqueResponse
        },
        'Powerlevels': {
          'IsShow': true,
          'SupportWrite': true,
          'Function': this.funcWritePowerLevels
        },
        'PowerlevelsAdjustment': {
          'IsShow': true,
          'SupportWrite': false,
          'Function': this.funcWritePowerLevels
        },
        'AutoSleep': {
          'IsShow': true,
          'SupportWrite': true,
          'Function': this.funcWriteAutoSleep
        },
        'MaintenanceWarning': {
          'IsShow': true,
          'SupportWrite': true,
          'Function': this.funcWriteMaintenanceWarning
        },
        'NextMaintenanceODO': {
          'IsShow': true,
          'SupportWrite': true,
          'Function': this.funcWriteNextMaintenanceODO
        },
        'StartUpLightON': {
          'IsShow': true,
          'SupportWrite': true,
          'Function': this.funcWriteStartUpLightON
        },
        'SpeedUnits': {
          'IsShow': true,
          'SupportWrite': true,
          'Function': this.funcWriteSpeedUnits
        },
        'WriteSpeedLimit': {
          'IsShow': false,
          'SupportWrite': true,
          'Function': this.funcWriteSpeedLimit
        },
        'StartUpPowerLevel': {
          'IsShow': true,
          'SupportWrite': true,
          'Function': this.funcWriteStartUpPowerLevel
        },
        'WriteWheelSize': {
          'IsShow': true,
          'SupportWrite': false,
          'Function': this.funcWriteWheelSize
        }
      },
      boolLockFeatures: false
    };
  },
  mounted () {
    // this.wheelSizeDisabled()
    this.funcCheckIsHaveDriver();
    this.funcCheckIsHaveDisplay();
    this.paraVer = this.bikeInfo['ParaVer'];
  },
  components: {
    Loading,
    InputRange
  },
  watch: {
    bikeInfo: {
      handler () {
        // 偵測到拿取bike info, 改變畫面
        this.bikeODO = this.bikeInfo['ODO'];
        this.settingParameter['UserInterfacePresent']['IsShow'] = this.bikeInfo['ParaVer'] >= 'B0001';
        this.settingParameter['ConnectModulePresent']['IsShow'] = this.bikeInfo['ParaVer'] >= 'B0001';
        this.settingParameter['TirePressurePresent']['IsShow'] = this.bikeInfo['ParaVer'] >= 'B0001';
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      bikeInfo: 'bikeInformation/getBikeInfoList',
      bikeSystemInfo: 'bikeInformation/getBikeSystemInfo',
      deviceInfo: 'bikeConnect/getDeviceInfo'
    }),
    restoreBtnDisable () {
      if (this.ParaVer >= 'B0001') {
        return false;
      }
      return true;
    },
    maintenanceError () {
      let reg = /^-?\d+$/;
      if (this.maintenanceODO < this.bikeODO) {
        return { status: true, text: this.$t('setting.msg.mustthanODO') };
      } else if (!reg.test(this.maintenanceODO)) {
        return { status: true, text: this.$t('setting.msg.mustInteger') };
      } else if (this.maintenanceODO > 40000) {
        return { status: true, text: this.$t('setting.msg.limitODO') };
      } else {
        return { status: false, text: '' };
      }
    },
    stepSetting () {
      var count = 0;
      var stepFinalSetting = {};
      let arrSettingkey = Object.keys(this.settingParameter);
      arrSettingkey.forEach((item, index) => {
        if (this.settingParameter[item]['IsShow'] && this.settingParameter[item]['SupportWrite']) {
          count += 1;
          var step = 'Step' + (count);
          stepFinalSetting[step] = this.settingParameter[item]['Function'];
        }
      });
      return stepFinalSetting;
    },
    StepCounts () {
      return Object.keys(this.stepSetting).length;
    },
    isHideBtn () {
      return !this.boolDisconnect;
    }
  },
  methods: {
    funcCheckDriverNeedLockFeatures () {
      // delete this feature because 不符合現況了
      let strDriverOriginalPartNo = funcOriginalPartNo(this.deviceInfo['DriverPN']);
      let arrSpeedBikeDriver = ['0002D18B', '0002D18D'];
      if (arrSpeedBikeDriver.includes(strDriverOriginalPartNo)) {
        let strDriverFWVer = this.funcGetDriverFWVer();
        if (strDriverFWVer >= 'A09') {
          this.settingParameter.TorqueResponse.IsShow = false;
          // this.funcLockFeatures();
        }
      }
    },
    funcLockFeatures () {
      // delete this feature because 不符合現況了
      this.settingParameter.TorqueResponse.IsShow = false;
      // this.boolLockFeatures = true
      // this.funcChangePerformanceMode('CLIMBING');
    },
    funcGetDriverFWVer () {
      let arrFwList = this.bikeSystemInfo['FwList'];
      let intFwListLength = arrFwList.length;
      let strFwVer = '';

      for (let i = 0; i < intFwListLength; i++) {
        if (arrFwList[i].Device === 'Driver') {
          strFwVer = arrFwList[i].FwVer;
          break;
        }
      }

      return strFwVer;
    },
    funcOpenDialog (title, content, okaction, cancelaction) {
      /**
       * modal.default true -> 1 button (OK)
       * modal.default false -> 2 buttons (OK, Cancel)
       * modal.data.content -> Dialog message
       * modalOpen true -> open Dialog
       * modalOpen false -> close Dialog
       */
      this.modal.btn = {
        ok: this.$t('bikeOverview.modalBtnOk'),
        cancel: this.$t('bikeOverview.modalBtnCancel')
      };
      this.modal.data.content = content;
      this.modal.data.title = title;
      this.modal.btnAction.ok = okaction || this.funcCloseDialog;
      this.modal.btnAction.cancel = cancelaction || this.funcCloseDialog;
      this.modalOpen = true;
    },
    funcCloseDialog () {
      this.modalOpen = false;
    },
    funcChangePerformanceMode (mode) {
      if (this.boolLockFeatures) {
        if (mode === 'TREKKING' || mode === 'CITY') {
          return;
        }
      }
      clearInterval(this.timeInterval);
      let dictPerfMode = { 'CITY': 'City', 'TREKKING': 'Trekking', 'CLIMBING': 'MTB' };
      this.driverPowerInfo.PerfMode = dictPerfMode[mode];
      // this.inputRangeVal.powerlevelAdjust = Array.from(this.inputRangeVal.powerlevelAdjustCache);
    },
    funcCheckNowStep () {
      this.settingStepCount += 1;
      let step = 'Step' + this.settingStepCount;
      console.info('<Setting>', step, 'exec', this.stepSetting[step].name);
      this.stepSetting[step]();
    },
    funcCheckIsHaveDriver () {
      let isHaveDriver = false;
      let arrsystemInfo = this.bikeSystemInfo['FwList'];
      arrsystemInfo.forEach((item) => {
        if (item.Type === 'D') isHaveDriver = true;
      });
      let paraVer = this.bikeInfo['ParaVer'];
      this.settingParameter['PowerlevelsAdjustment']['IsShow'] = !!(isHaveDriver && paraVer >= 'B0001');
      this.settingParameter['TorqueResponse']['IsShow'] = !!(isHaveDriver && paraVer >= 'B0001');
      this.funcCheckDriverNeedLockFeatures();
      this.checkDriverIsWriteSpeedLimit();
    },
    checkDriverIsWriteSpeedLimit () { // 確認是否為特定 PN & FwVer 則須修改限速
      let filterDriverPN = funcOriginalPartNo(this.deviceInfo['DriverPN']);
      const driverFWVer = this.funcGetDriverFWVer();
      const changeSpeedLimitList = [
        {
          partNo: '0002D18C',
          fwVer: 'A08'
        },
        {
          partNo: '0002D18A',
          fwVer: 'A06'
        }
      ];
      const isWriteSpeedLimit = changeSpeedLimitList.some(part => {
        return filterDriverPN === part.partNo && driverFWVer > part.fwVer;
      });
      this.settingParameter.WriteSpeedLimit.IsShow = isWriteSpeedLimit;
    },
    funcCheckIsHaveDisplay () {
      let isHaveDisplay = false;
      let arrsystemInfo = this.bikeSystemInfo['FwList'];
      arrsystemInfo.forEach((item) => {
        if (item.Type === 'P') isHaveDisplay = true;
      });
      this.settingParameter.EnergyIndicator['IsShow'] = isHaveDisplay;
      this.settingParameter.SpeedUnits['IsShow'] = true;
    },
    funcGetCommonCustomizenInfo () {
      this.ws.GetCommonCustomizenInfo();
    },
    funcBindCommonCustomizenInfo (mgData) {
      // console.log('BindCommonCustomizenInfo() <-', mgData);
      // only in very old Gorilla default
      const defaultDriverPower = {
        "Levels": 3,
        "PerfMode":"City",
        "PowerLV":[]
      }
      mgData.DrivePowerInfo = mgData.DrivePowerInfo || defaultDriverPower
      this.maintenanceODO = mgData.NextMaintenance;
      this.inputRangeVal.autoSleep = mgData.SysAutoSleep;
      this.energyIndicatorBar = mgData.EnergyIndicator;
      this.lightOnStart = mgData.StartUpLight;
      this.speedUnits = mgData.SpeedUnit;
      if (this.speedUnits === 255) {
        this.settingParameter['SpeedUnits']['IsShow'] = true;
        this.settingParameter['SpeedUnits']['SupportWrite'] = true;
      }
      this.powerLevelStart = mgData.AssistMode;
      this.inputRangeVal.wheelSize = mgData.WheelSize;
      this.torqueResponse = mgData.TorqueResponse;
      this.maintenanceWarnings = mgData.ShowMaintenanceWarning;
      // this.maintenanceODO = mgData.
      this.driverPowerInfo = mgData.DrivePowerInfo;
      this.inputRangeVal.powerlevelAdjust = this.driverPowerInfo.PowerLV;
      this.inputRangeVal.powerlevelAdjustCache = Array.from(this.inputRangeVal.powerlevelAdjust);

      // this.regenerativeBreaking=mgData
      // 儲存一份一開始讀取的資料
      var readData = {
        maintenanceODO: mgData.NextMaintenance,
        energyIndicatorBar: mgData.EnergyIndicator,
        lightOnStart: mgData.StartUpLight,
        speedUnits: mgData.SpeedUnit,
        powerLevelStart: mgData.AssistMode,
        wheelSize: mgData.WheelSize,
        torqueResponse: mgData.TorqueResponse,
        driverPowerInfo: Object.assign({}, mgData.DrivePowerInfo),
        // maintenanceODO:ss.getItem('bikeInfoList')["NextMaintenance"],
        maintenanceWarnings: mgData.ShowMaintenanceWarning,
        autoSleep: mgData.SysAutoSleep,
        powerlevelAdjust: Object.assign([], mgData.DrivePowerInfo.PowerLV)
      };
      // console.log('readData',readData)
      Object.assign(this.readSettingData, readData);

      // this.funcCheckDriverNeedLockFeatures()
    },
    funcGetSystemConfig (mgData) {
      this.ws.GetSystemConfig();
    },
    funcBindSystemConfig (mgData) {
      this.connectModulePresent = {
        IotModule: mgData.IotModule,
        SmartLock: mgData.SmartLocl,
        Battery: mgData.Battery,
        Driver: mgData.Driver,
        Display: mgData.Display,
        Console: mgData.Console
      };
      // console.log("TCL: funcBindSystemConfig -> this.connectModulePresent", this.connectModulePresent)
      if (mgData.FrontTpms === 1 || mgData.RearTpm === 1) {
        this.tirepressurePresent = 1;
      } else {
        this.tirepressurePresent = 0;
      }
      this.userInterfacePresent = mgData.Display;
      var readData = {
        IotModule: mgData.IotModule,
        SmartLock: mgData.SmartLocl,
        Battery: mgData.Battery,
        Driver: mgData.Driver,
        Display: mgData.Display,
        Console: mgData.Console
      };
      Object.assign(this.readSettingData.connectModulePresent, readData);
      this.readSettingData.tirepressurePresent = this.tirepressurePresent;
      this.readSettingData.userInterfacePresent = mgData.Display;
    },
    funcWriteMaintenanceWarning () {
      this.ws.WriteMaintenanceWarning(parseInt(this.maintenanceWarnings));
    },
    funcWriteNextMaintenanceODO () {
      this.ws.WriteNextMaintenanceODO(parseInt(this.maintenanceODO));
    },
    funcWriteEnergyBar () {
      this.ws.WriteEnergyBar(parseInt(this.energyIndicatorBar));
    },
    funcWriteStartUpLightON () {
      this.ws.WriteStartUpLightON(parseInt(this.lightOnStart));
    },
    funcWriteSpeedUnits () {
      this.ws.WriteSpeedUnits(parseInt(this.speedUnits));
    },
    funcWriteSpeedLimit () {
      this.speedLimit = parseInt(this.speedUnits) ? 32 : 25;
      this.ws.WriteParameters({
        PartType: 'DRIVER',
        Parameters: {
          SpeedLimit: this.speedLimit
        }
      });
    },
    funcWriteStartUpPowerLevel () {
      this.ws.WriteStartUpPowerLevel(parseInt(this.powerLevelStart));
    },
    funcWriteWheelSize () {
      this.ws.WriteWheelSize(parseInt(this.inputRangeVal.wheelSize));
    },
    funcWriteAutoSleep () {
      // 避免 autoSleep 寫入 0
      this.inputRangeVal.autoSleep = parseInt(this.inputRangeVal.autoSleep) <= 0 ? 1 : this.inputRangeVal.autoSleep;
      this.ws.WriteAutoSleep(parseInt(this.inputRangeVal.autoSleep));
    },
    functionPowerLvCacheUpdate () {
      this.inputRangeVal.powerlevelAdjustCache = Array.from(this.inputRangeVal.powerlevelAdjust);
    },
    funcDriverPowerLv (strPerMode, intLevels) {
      let dictDriverAstTable = {
        'City': {
          1: [1],
          2: [1, 4],
          3: [1, 4, 7],
          4: [1, 4, 7, 10],
          5: [1, 4, 7, 10, 13]
        },
        'Trekking': {
          1: [2],
          2: [2, 5],
          3: [2, 5, 8],
          4: [2, 5, 8, 11],
          5: [2, 5, 8, 11, 14]
        },
        'MTB': {
          1: [3],
          2: [3, 6],
          3: [3, 6, 9],
          4: [3, 6, 9, 12],
          5: [3, 6, 9, 12, 15]
        }
      };
      return dictDriverAstTable[strPerMode][intLevels];
    },
    funcWritePowerLevels () {
      // 如果 可以調整 PowerLevels 則透過 "拉環" 調整，若無法則單純調整 Mode
      let dictPerfMode = { 'City': 'CITY', 'Trekking': 'TREKKING', 'MTB': 'CLIMBING' };
      let mgPerfMode = dictPerfMode[this.driverPowerInfo.PerfMode];
      if (this.settingParameter.PowerlevelsAdjustment.IsShow) {
        let listPowerAdjust = this.inputRangeVal.powerlevelAdjust
          .map(power => parseInt(power));
        /*
        let listChangePowerAdjust = this.funcDriverPowerLv(this.driverPowerInfo.PerfMode, this.driverPowerInfo.Levels)
          .map(level => listPowerAdjust[level]);
        console.log('WritePowerLevels():', this.driverPowerInfo.PerfMode, listPowerAdjust, '|>', listChangePowerAdjust);
        this.ws.WritePowerLevels(mgPerfMode, listChangePowerAdjust, parseInt(this.driverPowerInfo.Levels));
        */
        console.log('WritePowerLevels():', this.driverPowerInfo.PerfMode, listPowerAdjust);
        this.ws.WritePowerLevels(mgPerfMode, listPowerAdjust, parseInt(this.driverPowerInfo.Levels));
      } else {
        this.ws.WritePowerLevels(mgPerfMode, [], parseInt(this.driverPowerInfo.Levels));
      }
    },
    fucnWriteTorqueResponse () {
      this.ws.WriteTorqueResponse(parseInt(this.torqueResponse));
    },
    funcSaveSetting () {
      this.isLoading = true;
      clearInterval(this.timeInterval);
      this.funcCheckNowStep();
    },
    funcResetSetting () {
      // reset bike value through messagegateway
      clearInterval(this.timeInterval);
      this.restoreFlag = true;
      this.isLoading = true;
      this.ws.ResetSetting();
    },
    functionRestoreDefault () {
      // for setting write & read
      this.inputRangeVal.autoSleep = this.readSettingData.autoSleep;
      this.energyIndicatorBar = this.readSettingData.energyIndicatorBar;
      this.lightOnStart = this.readSettingData.lightOnStart;
      this.speedUnits = this.readSettingData.speedUnits;
      this.powerLevelStart = this.readSettingData.powerLevelStart;
      this.inputRangeVal.wheelSize = this.readSettingData.wheelSize;
      this.torqueResponse = this.readSettingData.torqueResponse;
      this.maintenanceWarnings = this.readSettingData.maintenanceWarnings;
      this.maintenanceODO = this.readSettingData.maintenanceODO;
      this.driverPowerInfo = Object.assign({}, this.readSettingData.driverPowerInfo);
      this.inputRangeVal.powerlevelAdjust = Object.assign([], this.readSettingData.powerlevelAdjust);
      this.userInterfacePresent = this.readSettingData.userInterfacePresent;
      this.connectModulePresent = Object.assign({}, this.readSettingData.connectModulePresent);
      this.tirepressurePresent = this.readSettingData.tirepressurePresent;
    },
    funcApplyData () {
      this.readSettingData.autoSleep = this.inputRangeVal.autoSleep;
      this.readSettingData.energyIndicatorBar = this.energyIndicatorBar;
      this.readSettingData.lightOnStart = this.lightOnStart;
      this.readSettingData.speedUnits = this.speedUnits;
      this.readSettingData.powerLevelStart = this.powerLevelStart;
      this.readSettingData.wheelSize = this.inputRangeVal.wheelSize;
      this.readSettingData.torqueResponse = this.torqueResponse;
      this.readSettingData.maintenanceWarnings = this.maintenanceWarnings;
      this.readSettingData.maintenanceODO = this.maintenanceODO;
      this.readSettingData.driverPowerInfo = Object.assign({}, this.driverPowerInfo);
      this.readSettingData.powerlevelAdjust = Object.assign([], this.inputRangeVal.powerlevelAdjust);
      this.readSettingData.userInterfacePresent = this.userInterfacePresent;
      this.readSettingData.connectModulePresent = Object.assign({}, this.connectModulePresent);
      this.readSettingData.tirepressurePresent = this.tirepressurePresent;
    },
    funcCheckIsFinalStep () {
      // console.log("現在步驟",this.settingStepCount)
      // console.log("總共步驟",this.StepCounts)
      if (this.StepCounts === this.settingStepCount) {
        this.settingStepCount = 0;
        this.ws.GetBikeInfo();
        return true;
      } else {
        return false;
      }
    },
    funcGoToConnect () {
      this.$router.push('/connect');
    },
    funcOkBtnDialog () {
      this.modalOpenDisconnect = false;
      this.$router.push('/connect');
    }
    // wheelSizeDisabled () {
    //   document.getElementById("wheelSize").disabled = false
    // }
  }
};
</script>

<style lang="scss" scoped>
.error-red{
  color: red
}
input[type=range] {
    margin: auto;
    outline: none;
    padding: 0;
    height: 6px;
    background-color: $grey;
    background-image: -webkit-gradient(linear, 50% 0%, 50% 100%, color-stop(0%, $main_color), color-stop(100%, darken($main_color,10%)));
    background-image: -webkit-linear-gradient($main_color, darken($main_color,10%));
    background-image: -moz-linear-gradient($main_color, darken($main_color,10%));
    background-image: -o-linear-gradient($main_color, darken($main_color,10%));
    background-image: linear-gradient($main_color, $main_color);
    background-size: 50% 100%;
    background-repeat: no-repeat;
    border-radius: 10px;
    cursor: pointer;
    -webkit-appearance: none;
}

input[type=range]::-webkit-slider-runnable-track {
    box-shadow: none;
    border: none;
    background: transparent;
    -webkit-appearance: none;
}

input[type=range]::-moz-range-track {
    box-shadow: none;
    border: none;
    background: transparent;
}

input[type=range]::-moz-focus-outer {
    border: 0;
}

input[type=range]::-webkit-slider-thumb {
    width: 16px;
    height: 16px;
    border: 0;
    background: $main_color;
    border-radius: 100%;
    box-shadow: 0 0 1px 0px rgba(0,0,0,0.1);
    -webkit-appearance: none;
}

input[type=range]::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border: 0;
    background: $main_color;
    border-radius: 100%;
    box-shadow: 0 0 1px 0px rgba(0,0,0,0.1);
}

input[type="range"]::-ms-thumb {
    width: 16px;
    height: 16px;
    border: none;
    background: $main_color;
    border-radius: 50%;
    box-shadow: 0 0 0 7px #999; // box-shadow color should match the background
}
</style>
